import axios from "../configs/axios.config";

const SERVER = import.meta.env.VITE_API_URL;

// ---------------- FETCH ALL ROLES ----------------
const fetchRoles = async () => {
  try {
    const token = localStorage.getItem("prima_session");
    if (!token) throw new Error("Token not found");

    const response = await axios.get(`${SERVER}/roles/all`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    return response.data?.data;
  } catch (error) {
    console.error(
      "Error fetching roles:",
      error.response?.data?.message || error.message,
    );
    throw new Error(error.response?.data?.message || "Failed to fetch roles");
  }
};

// ---------------- ADD ROLE ----------------
const addRole = async (payload) => {
  if (!payload) throw new Error("Payload not found");

  const token = localStorage.getItem("prima_session");
  if (!token) throw new Error("Token not found");

  try {
    const response = await axios.post(`${SERVER}/roles/add`, payload, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to add role");
  }
};

// ---------------- GET ROLE BY ID ----------------
const getRoleById = async (id) => {
  if (!id) throw new Error("Role ID not provided");

  const token = localStorage.getItem("prima_session");
  if (!token) throw new Error("Token not found");

  try {
    const response = await axios.get(`${SERVER}/roles/details/${id}`, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    return response.data?.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch role");
  }
};

// ---------------- UPDATE ROLE (FIXED) ----------------
const updateRole = async (id, payload, token) => {
  if (!id) throw new Error("Role ID not provided");
  if (!payload) throw new Error("Payload not provided");
  if (!token) throw new Error("Token not found");

  try {
    const response = await axios.patch(
      `${SERVER}/roles/${id}`, // ✅ id is string
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      },
    );

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update role");
  }
};

// ---------------- DELETE ROLE ----------------
const deleteRole = async (id) => {
  if (!id) throw new Error("Role ID not provided");

  const token = localStorage.getItem("prima_session");
  if (!token) throw new Error("Token not found");

  try {
    const response = await axios.delete(`${SERVER}/roles/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to delete role");
  }
};
const fetchDashboardDropdownRoles = async () => {
  const token = localStorage.getItem("prima_session");
  if (!token) throw new Error("Token not found");

  try {
    const response = await axios.get(`${SERVER}/roles/dashboard-dropdown`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    return response.data?.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "Failed to fetch dashboard dropdown roles"
    );
  }
};

// ---------------- EXPORTS ----------------
export { fetchRoles, addRole, getRoleById, updateRole, deleteRole, fetchDashboardDropdownRoles };
